import { render, staticRenderFns } from "./ReviewQualityControl.vue?vue&type=template&id=39b56a57&scoped=true"
import script from "./ReviewQualityControl.vue?vue&type=script&lang=js"
export * from "./ReviewQualityControl.vue?vue&type=script&lang=js"
import style0 from "./ReviewQualityControl.vue?vue&type=style&index=0&id=39b56a57&prod&scoped=true&lang=css"
import style1 from "./ReviewQualityControl.vue?vue&type=style&index=1&id=39b56a57&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b56a57",
  null
  
)

export default component.exports